import React from 'react';
import { Offcanvas } from '../Offcanvas/Offcanvas';
import { useDispatch, useSelector } from 'react-redux';
import { isOptionsSidebarVisibleSelector } from '../../../modules/selectors/optionsSidebar';
import { hideOptionsSidebar, setIsOptionsSidebarVisible } from '../../../modules/actions/optionsSidebar';

function OptionsSidebar({ children, title = 'Filter' }) {
    const isOptionsSidebarVisible = useSelector(isOptionsSidebarVisibleSelector);
    const dispatch = useDispatch();

    return (
        <div className="sidebar-container uk-width-1-4@m">
            <Offcanvas
                className="sidebar"
                overlay
                isVisible={isOptionsSidebarVisible}
                onIsVisibleChange={isVisible => dispatch(setIsOptionsSidebarVisible({ isVisible }))}
                flip={false}
            >
                <div className="uk-offcanvas-bar uk-padding-remove">
                    <header className="uk-card-header uk-flex uk-flex-middle aps-border-bottom uk-light">
                        <div className="uk-grid-collapse uk-flex-1 uk-grid" data-uk-grid="">
                            <div className="uk-width-expand">
                                <h3>{title}</h3>
                            </div>
                            <button
                                className="uk-offcanvas-close uk-close uk-icon"
                                type="button"
                                data-uk-close=""
                                onClick={() => dispatch(hideOptionsSidebar())}
                            />
                        </div>
                    </header>
                    <div className="uk-card uk-card-default uk-card-small uk-flex uk-flex-column">
                        <ul className="uk-margin-remove uk-flex-1 uk-accordion" data-uk-accordion="multiple: true; targets: section">
                            {children}
                        </ul>
                    </div>
                </div>
            </Offcanvas>
        </div>
    );
}

export default OptionsSidebar;
